// extracted by css-extract-rspack-plugin
export default {"Footer":"view-changes-button-module__Footer__ZhfaY"};